import { render, staticRenderFns } from "./TeacherReviewChange.vue?vue&type=template&id=6d242837&scoped=true"
import script from "./TeacherReviewChange.vue?vue&type=script&lang=js"
export * from "./TeacherReviewChange.vue?vue&type=script&lang=js"
import style0 from "./TeacherReviewChange.vue?vue&type=style&index=0&id=6d242837&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d242837",
  null
  
)

export default component.exports